module.exports = __webpack_public_path__ + "img/img1.94c11eff.jpg";